export default __webpack_public_path__ + "static/media/meesho.83a04ce0.svg";